module.exports = __webpack_public_path__ + "img/XC.2b2ce33b.png";